module.exports = __webpack_public_path__ + "img/acc5.5792323f.png";